import React from 'react';
import withLanguage from "../../../HOC/withLanguage";



function InformationAndImages({language}) {



    return (

        <section className="max-w-6xl mx-auto rounded-t-[10px] bg-white border border-gray-100 shadow-custom !border-b-0 p-8">
            <div>

                <div className="flex items-start gap-6 mb-10">
                    <img
                        src="/dual/Picture6.png"
                        alt="Description"
                        className="w-auto h-auto"
                    />

                    <div>
                        <h2 className="text-red-600 font-extrabold text-[20px] mb-2">
                            {language.mainTitle2}
                        </h2>
                        <p className="text-gray-700 mb-0 font-extrabold max-w-[400px]">
                            {language.subText2}
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
                    {/* 1st Image */}
                    <div className="flex flex-col items-center">
                        <a href="/KualifikimDual?page=QualificationFilters">
                            <img
                                src="/dual/Picture1.png"
                                alt="Qualification"
                                className="h-full w-full object-cover rounded-2xl"
                            />
                        </a>
                        <p className="text-gray-800 font-bold text-center mt-2">{language.imageText1}</p>
                    </div>


                    {/* 2nd Image */}
                    <div className="flex flex-col items-center">
                        <a href="/KualifikimDual?page=SchoolFilters">
                            <img
                                src="/dual/Picture2.png"
                                alt="School"
                                className="h-full w-full object-cover rounded-2xl"
                            />
                        </a>
                        <p className="text-gray-800 font-bold text-center max-w-[90px]">{language.imageText2}</p>
                    </div>

                    {/* 3rd Image */}
                    <div className="flex flex-col items-center">
                        <a href="http:/Punedhenes">
                            <img
                                src="/dual/Picture3.png"
                                alt="Business"
                                className="h-full w-full object-cover rounded-2xl"
                            />
                        </a>
                        <p className="text-gray-800 font-bold text-center">{language.imageText3}</p>
                    </div>


                    {/* 4th Image */}
                    <div className="flex flex-col items-center">
                        <a href="/KualifikimDual?page=EmploymentFilter">
                            <img
                                src="/dual/Picture4.png"
                                alt="Employment"
                                className="h-full w-full object-cover rounded-2xl"
                            />
                        </a>
                        <p className="text-gray-800 font-bold text-center mt-2">{language.imageText4}</p>
                    </div>

                </div>
            </div>
        </section>

    );
}


export default withLanguage(InformationAndImages, "InformationAndImages");
